interface ProgressBarProps {
  current: number;
  max: number;
  label?: string;
  color?: string;
}

export function ProgressBar({ current, max, label, color = '#d9b3ff' }: ProgressBarProps) {
  const pct = Math.min(100, Math.max(0, (current / max) * 100));
  return (
    <div className="progress">
      {label && (
        <div className="progress__label">
          <span>{label}</span>
          <span>
            {current} / {max}
          </span>
        </div>
      )}
      <div className="progress__track">
        <div
          className="progress__fill"
          style={{ width: `${pct}%`, background: color }}
        />
      </div>
    </div>
  );
}
